import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';


@NgModule({
    imports: [
      CommonModule,
      
    ],
    exports: [
      LoadingComponent
    ],
    providers: [
    ],
    declarations: [
      LoadingComponent
    ]
  })
  export class LoadingModule { }
